import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';

const NavItem = ({
    path,
    children,
    exact = false,
    icon,
    isCta = false
}) => {
    const location = useLocation();

    const isActive = exact
        ? location.pathname === path
        : location.pathname.startsWith(path);

    const linkClass = `${styles.navLink} ${isActive ? styles.active : ''} ${isCta ? styles.ctaItem : ''
        }`;

    if (path.startsWith('http') || path.startsWith('tel') || path.startsWith('mailto')) {
        return (
            <li className={styles.navItem}>
                <a
                    href={path}
                    className={linkClass}
                    target={path.startsWith('http') ? '_blank' : '_self'}
                    rel={path.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                    {icon && <span className={styles.icon}>{icon}</span>}
                    {children}
                </a>
            </li>
        );
    }

    return (
        <li className={styles.navItem}>
            <Link to={path} className={linkClass}>
                {icon && <span className={styles.icon}>{icon}</span>}
                {children}
            </Link>
        </li>
    );
};

export default NavItem;